export default {
    fields: [
        {
            key: "event",
            label: "Event",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
        {
            key: "datetime",
            label: "Date event",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "email",
            label: "Email",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
        {
            key: "message_id",
            label: "Message ID",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
        {
            key: "template_id",
            label: "Template ID",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
        {
            key: "reason",
            label: "Reason",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    currentPage: 1,
    matchResponseCurrentPage: "currentPage",
    pages: 1,
    matchResponsePages: "pages",
    loading: false,
    hover: true,
    pagination: false,
    sorter: {
        external: true,
        resetable: true
    },
    sorterValue: {},
    size: "sm",
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null,
    matchResponse: "items",
}